import { NAV_KEYS, SMART_LIBRARY_PATHS, ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
import { ANALYTICS_SUITE_TAB_CONFIG } from '../constants/navigation';
import { getAccessProperties } from './categoryUtils';
export const getActiveNavItem = pathname => {
  if (pathname.startsWith(SMART_LIBRARY_PATHS[NAV_KEYS.ANALYTICS_SUITE])) {
    return NAV_KEYS.ANALYTICS_SUITE;
  }
  return NAV_KEYS.USER_LIBRARY;
};
export const buildAnalyticsSuitePath = (tabId, filters) => {
  const basePath = SMART_LIBRARY_PATHS[NAV_KEYS.ANALYTICS_SUITE];
  if (!tabId) {
    return basePath;
  }
  const path = `${basePath}/${tabId}`;
  if (!filters || Object.keys(filters).length === 0) {
    return path;
  }
  const searchParams = new URLSearchParams();
  if (filters.useCase) {
    searchParams.set('useCase', filters.useCase);
  }
  if (filters.type) {
    searchParams.set('type', filters.type);
  }
  if (filters.dataType) {
    searchParams.set('dataType', filters.dataType);
  }
  const queryString = searchParams.toString();
  return queryString ? `${path}?${queryString}` : path;
};
export const isValidTabId = tabId => {
  if (!tabId) return false;
  return Object.values(ANALYTICS_SUITE_TAB_IDS).includes(tabId);
};
export const getAnalyticsSuiteFilters = searchParams => {
  const filters = {};
  if (searchParams) {
    const useCase = searchParams.get('useCase');
    if (useCase) {
      filters.useCase = useCase;
    }
    const type = searchParams.get('type');
    if (type) {
      filters.type = type;
    }
    const dataType = searchParams.get('dataType');
    if (dataType) {
      filters.dataType = dataType;
    }
  }
  return filters;
};
export const getAnalyticsSuiteTabConfig = (gates, scopes) => {
  return ANALYTICS_SUITE_TAB_CONFIG.map(tab => {
    const accessProperties = getAccessProperties(tab.tabId, gates, scopes);
    return Object.assign({}, tab, {
      accessProperties
    });
  });
};